module.exports = __webpack_public_path__ + "static/media/koma.c2698845.jpeg";